import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-align-center" }

import VueQrcode from 'vue-qrcode';
  import {ref} from "vue";
  import {getApplication} from "@config/application";
  import {useApp} from "@hview/hview-vue3/packages/hooks/use-app";
  
import { defineComponent } from 'vue'
const __default__ = defineComponent({
  name: "QrDialog",
  
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

  const {visible} = useApp();
  const qrString = ref("https://www.baidu.com");


  const open = (value: any) => {
    visible.value = true;
    qrString.value = `${getApplication().baseurl}${getApplication().qrcodePrefix}/type=scanDoctorTeam&projectId=${value.id}`;
    console.info(qrString.value)
  }

  __expose({
    open
  });

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    title: "查看二维码",
    modelValue: _unref(visible),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
    width: "750"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(VueQrcode), {
          type: "image/png",
          color: "#333333",
          value: qrString.value,
          width: "350"
        }, null, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})